// extracted by mini-css-extract-plugin
var _1 = "container__oe8Aa";
var _2 = "noResults__o4jVy";
export { _1 as "container", _2 as "noResults" }
